

































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Cart from '@/components/Cart.vue';
import RoomSearchBar from '@/components/RoomSearchBar.vue';
import RoomInfoModal from '@/views/sale/room-info.modal.vue';
import { compass } from '@resclick/compass';
import { Action, Getter, State } from 'vuex-class';
import { QueryState } from '@/store/query/types';
import { date } from 'quasar';
import getDateDiff = date.getDateDiff;
import { IFile } from '@resclick/data-access';
import { scroll } from 'quasar';

const { getScrollTarget, setScrollPosition } = scroll;

function scrollToElement(el: HTMLElement) {
  const target = getScrollTarget(el);
  const offset = el.offsetTop;
  const duration = 300;
  setScrollPosition(target, offset, duration);
}

@Component({
  components: { RoomSearchBar, Cart, RoomInfoModal },
})
export default class RoomSearchStep extends Vue {
  @State('query') query!: QueryState;
  @Getter('widget/propertyId') propertyId!: string;
  @Getter('widget/stepMeta') stepMeta!: (id: number) => any;
  @Action('cart/addToCart') addToCart!: any;
  @Getter('cart/isLoading') isLoading!: boolean;
  @Getter('preferences/currency') currency!: string;

  infoDialog = {
    show: false,
    slides: [],
    room: {},
  };

  slideDialog = {
    show: false,
    currentSlide: 1,
    slides: [],
  };

  isSearching = false;
  // Shadow Query (Last Query)
  queryStore!: QueryState;
  totalNights = 0;
  searchResults = [];

  showSlideDialog(product: any) {
    this.slideDialog.show = true;
    this.slideDialog.currentSlide = 1;
    this.slideDialog.slides = product.images;
  }

  onAddToCart(params: any) {
    if (this.$q.screen.lt.md) {
      scrollToElement(document.querySelector('#shopping-cart') as HTMLElement);
    }
    this.addToCart(params);
  }

  imagePath(image: IFile, size: keyof IFile['sizes']) {
    if (image?.sizes?.[size]) {
      return process.env.VUE_APP_CDN_URL + '/' + image.sizes[size];
    } else return '';
  }

  smallImage(image: IFile) {
    if (image?.sizes?.small) {
      return process.env.VUE_APP_CDN_URL + '/' + image.sizes.small;
    }
    return '';
  }

  onSearch() {
    this.isSearching = true;
    compass
      .do('prices', 'findByPropertyId', {
        query: { ...this.query, currency: this.currency },
        params: { propertyId: this.propertyId },
        populate: [{ path: 'images' }],
      })
      .then((res) => {
        this.searchResults = res.data;
        this.totalNights = getDateDiff(this.query.checkOutDate, this.query.checkInDate, 'days');
        this.queryStore = {
          adults: this.query.adults,
          children: this.query.children,
          checkInDate: this.query.checkInDate,
          checkOutDate: this.query.checkOutDate,
        };
      })
      .finally(() => {
        this.isSearching = false;
      });
  }

  mounted() {
    this.onSearch();
  }

  @Watch('currency')
  @Watch('$i18n.locale')
  refreshResults() {
    this.onSearch();
  }

  onContinue() {
    this.$emit('changeStep', this.stepMeta(0).next);
  }
}
